import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-update-menu',
  templateUrl: './dialog-update-menu.component.html',
  styleUrls: ['./dialog-update-menu.component.css']
})
export class DialogUpdateMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
